import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=4014d188&scoped=true&"
var script = {}
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=4014d188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014d188",
  null
  
)

export default component.exports